import Board from "components/Common/Board/Board";
import styled from "styled-components";

export const UserProfileFormBoard = styled(Board)`
  padding: 5rem;
  width: 70rem;

  display: flex;
  flex-direction: column;
  gap: 3.4rem;
  margin: 0 auto;

  h1 {
    ${({ theme }) => theme.typography.h1.bold};
  }
`;

export const UserProfileDescription = styled.p`
  padding: 0rem 0rem 0rem 1.4rem;
  ${({ theme }) => theme.typography.body3.regular};
  color: ${({ theme }) => theme.color.text.highEmphasis};
  font-size: 1.4rem;
`;

export const UserProfileFormFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;

  > button {
    flex: 1;
  }
`;
